import apiClient from 'services/axios'
import ApiConfig from 'services/config'

const { CommonConfig } = ApiConfig

export function getCountries() {
  return apiClient.get(CommonConfig.COUNTRY).then(res => res?.data?.countries ?? [])
}

export default function showBusinessTypes() {
  return apiClient
    .get(CommonConfig.BUSINESS_TYPES)
    .then(response => {
      if (response) {
        return response.data
      }
      return false
    })
    .catch(err => console.log(err))
}
